module.exports = __webpack_public_path__ + "img/成都汇美瑞亚.9c76d5c.png";